import React, { useEffect } from 'react';

function AdBanner({ 
  adSlot = "", 
  adFormat = "auto",
  responsive = true,
  style = {}
}) {
  useEffect(() => {
    try {
      // Push ad to Google AdSense queue
      if (window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error('AdSense error:', err);
    }
  }, [adSlot]);

  // Don't render if no ad slot is provided
  if (!adSlot) {
    return null;
  }

  return (
    <div className="ad-container" style={style}>
      <ins 
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-1642614853319842"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={responsive.toString()}
      ></ins>
    </div>
  );
}

export default AdBanner; 